import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './decorations.css';
import { DynamicViewOverlay } from '../../view/dynamicViewOverlay.js';
import { Range } from '../../../common/core/range.js';
import { HorizontalRange } from '../../../common/view/renderingContext.js';
export var DecorationsOverlay = /*#__PURE__*/function (_DynamicViewOverlay) {
  _inherits(DecorationsOverlay, _DynamicViewOverlay);

  var _super = _createSuper(DecorationsOverlay);

  function DecorationsOverlay(context) {
    var _this;

    _classCallCheck(this, DecorationsOverlay);

    _this = _super.call(this);
    _this._context = context;
    var options = _this._context.configuration.options;
    _this._lineHeight = options.get(51
    /* lineHeight */
    );
    _this._typicalHalfwidthCharacterWidth = options.get(36
    /* fontInfo */
    ).typicalHalfwidthCharacterWidth;
    _this._renderResult = null;

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(DecorationsOverlay, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      this._renderResult = null;

      _get(_getPrototypeOf(DecorationsOverlay.prototype), "dispose", this).call(this);
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      this._lineHeight = options.get(51
      /* lineHeight */
      );
      this._typicalHalfwidthCharacterWidth = options.get(36
      /* fontInfo */
      ).typicalHalfwidthCharacterWidth;
      return true;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return e.scrollTopChanged || e.scrollWidthChanged;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      var _decorations = ctx.getDecorationsInViewport(); // Keep only decorations with `className`


      var decorations = [],
          decorationsLen = 0;

      for (var i = 0, len = _decorations.length; i < len; i++) {
        var d = _decorations[i];

        if (d.options.className) {
          decorations[decorationsLen++] = d;
        }
      } // Sort decorations for consistent render output


      decorations = decorations.sort(function (a, b) {
        if (a.options.zIndex < b.options.zIndex) {
          return -1;
        }

        if (a.options.zIndex > b.options.zIndex) {
          return 1;
        }

        var aClassName = a.options.className;
        var bClassName = b.options.className;

        if (aClassName < bClassName) {
          return -1;
        }

        if (aClassName > bClassName) {
          return 1;
        }

        return Range.compareRangesUsingStarts(a.range, b.range);
      });
      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var visibleEndLineNumber = ctx.visibleRange.endLineNumber;
      var output = [];

      for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
        var lineIndex = lineNumber - visibleStartLineNumber;
        output[lineIndex] = '';
      } // Render first whole line decorations and then regular decorations


      this._renderWholeLineDecorations(ctx, decorations, output);

      this._renderNormalDecorations(ctx, decorations, output);

      this._renderResult = output;
    }
  }, {
    key: "_renderWholeLineDecorations",
    value: function _renderWholeLineDecorations(ctx, decorations, output) {
      var lineHeight = String(this._lineHeight);
      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var visibleEndLineNumber = ctx.visibleRange.endLineNumber;

      for (var i = 0, lenI = decorations.length; i < lenI; i++) {
        var d = decorations[i];

        if (!d.options.isWholeLine) {
          continue;
        }

        var decorationOutput = '<div class="cdr ' + d.options.className + '" style="left:0;width:100%;height:' + lineHeight + 'px;"></div>';
        var startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
        var endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);

        for (var j = startLineNumber; j <= endLineNumber; j++) {
          var lineIndex = j - visibleStartLineNumber;
          output[lineIndex] += decorationOutput;
        }
      }
    }
  }, {
    key: "_renderNormalDecorations",
    value: function _renderNormalDecorations(ctx, decorations, output) {
      var lineHeight = String(this._lineHeight);
      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var prevClassName = null;
      var prevShowIfCollapsed = false;
      var prevRange = null;

      for (var i = 0, lenI = decorations.length; i < lenI; i++) {
        var d = decorations[i];

        if (d.options.isWholeLine) {
          continue;
        }

        var className = d.options.className;
        var showIfCollapsed = Boolean(d.options.showIfCollapsed);
        var range = d.range;

        if (showIfCollapsed && range.endColumn === 1 && range.endLineNumber !== range.startLineNumber) {
          range = new Range(range.startLineNumber, range.startColumn, range.endLineNumber - 1, this._context.model.getLineMaxColumn(range.endLineNumber - 1));
        }

        if (prevClassName === className && prevShowIfCollapsed === showIfCollapsed && Range.areIntersectingOrTouching(prevRange, range)) {
          // merge into previous decoration
          prevRange = Range.plusRange(prevRange, range);
          continue;
        } // flush previous decoration


        if (prevClassName !== null) {
          this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShowIfCollapsed, lineHeight, visibleStartLineNumber, output);
        }

        prevClassName = className;
        prevShowIfCollapsed = showIfCollapsed;
        prevRange = range;
      }

      if (prevClassName !== null) {
        this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShowIfCollapsed, lineHeight, visibleStartLineNumber, output);
      }
    }
  }, {
    key: "_renderNormalDecoration",
    value: function _renderNormalDecoration(ctx, range, className, showIfCollapsed, lineHeight, visibleStartLineNumber, output) {
      var linesVisibleRanges = ctx.linesVisibleRangesForRange(range,
      /*TODO@Alex*/
      className === 'findMatch');

      if (!linesVisibleRanges) {
        return;
      }

      for (var j = 0, lenJ = linesVisibleRanges.length; j < lenJ; j++) {
        var lineVisibleRanges = linesVisibleRanges[j];

        if (lineVisibleRanges.outsideRenderedLine) {
          continue;
        }

        var lineIndex = lineVisibleRanges.lineNumber - visibleStartLineNumber;

        if (showIfCollapsed && lineVisibleRanges.ranges.length === 1) {
          var singleVisibleRange = lineVisibleRanges.ranges[0];

          if (singleVisibleRange.width === 0) {
            // collapsed range case => make the decoration visible by faking its width
            lineVisibleRanges.ranges[0] = new HorizontalRange(singleVisibleRange.left, this._typicalHalfwidthCharacterWidth);
          }
        }

        for (var k = 0, lenK = lineVisibleRanges.ranges.length; k < lenK; k++) {
          var visibleRange = lineVisibleRanges.ranges[k];
          var decorationOutput = '<div class="cdr ' + className + '" style="left:' + String(visibleRange.left) + 'px;width:' + String(visibleRange.width) + 'px;height:' + lineHeight + 'px;"></div>';
          output[lineIndex] += decorationOutput;
        }
      }
    }
  }, {
    key: "render",
    value: function render(startLineNumber, lineNumber) {
      if (!this._renderResult) {
        return '';
      }

      var lineIndex = lineNumber - startLineNumber;

      if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
        return '';
      }

      return this._renderResult[lineIndex];
    }
  }]);

  return DecorationsOverlay;
}(DynamicViewOverlay);